export enum QueryKey {
  ACTIVE_DATE_RANGE = 'activeDateRange',
  COMPARE_CAMPAIGNS = 'compareCampaigns',
  CUSTOM_CALENDAR_DATA_DATES = 'customCalendarDataDates',
  CUSTOM_CALENDAR_RANGE = 'customCalendarRange',
  GET_ADMIN_THREADS = 'getAdminThreads',
  GET_ADS_LIBRARY_PAGES_SEARCH = 'getAdsLibraryPagesSearch',
  GET_ADS_LIBRARY_PAGE_SUMMARY = 'getAdsLibraryPageSummary',
  GET_ADS_LIBRARY_SEARCH = 'getAdsLibrarySearch',
  GET_ADS_LIBRARY_SMART_INSIGHTS = 'getAdsLibrarySmartInsights',
  GET_AI_CHAT_CONVERSATION = 'getAiChatConversation',
  GET_AI_CHAT_CONVERSATIONS = 'getAiChatConversations',
  GET_AI_LISTENING_CAMPAIGN = 'getAiListeningCampaign',
  GET_AI_LISTENING_CAMPAIGNS = 'getAiListeningCampaigns',
  GET_AI_LISTENING_CAMPAIGN_BRANDS_ALONGSIDE = 'getAiListeningCampaignBrandsAlongside',
  GET_AI_LISTENING_CAMPAIGN_PROMPT_RESULTS = 'getAiListeningCampaignPromptResults',
  GET_AI_LISTENING_CAMPAIGN_RELOAD_HISTORY = 'getAiListeningCampaignReloadHistory',
  GET_AI_LISTENING_CAMPAIGN_RELOAD_STATUS = 'getAiListeningCampaignReloadStatus',
  GET_AI_LISTENING_CAMPAIGN_RESPONSES = 'getAiListeningCampaignResponses',
  GET_AI_LISTENING_CAMPAIGN_SMART_INSIGHTS = 'getAiListeningCampaignSmartInsights',
  GET_AI_LISTENING_OVERVIEW = 'getAiListeningOverview',
  GET_AI_LISTENING_PROFILE = 'getAiListeningProfile',
  GET_AI_LISTENING_PROFILES = 'getAiListeningProfiles',
  GET_AI_LISTENING_PROFILE_COMPETITORS = 'getAiListeningProfileCompetitors',
  GET_AI_LISTENING_PROFILE_DASHBOARD = 'getAiListeningProfileDashboard',
  GET_AI_LISTENING_PROFILE_PROMPTS = 'getAiListeningProfilePrompts',
  GET_AI_LISTENING_PROFILE_PROMPTS_OVERVIEW = 'getAiListeningProfilePromptsOverview',
  GET_AI_LISTENING_PROFILE_SITE_AUDIT = 'getAiListeningProfileSiteAudit',
  GET_AI_LISTENING_PROMPT_CONTEXT = 'getAiListeningPromptContext',
  GET_AI_LISTENING_PROMPT_DEEP_DIVE = 'getAiListeningPromptDeepDive',
  GET_AI_SUMMARIES = 'getAISummaries',
  GET_ALL_SENTIMENT_ANALYSIS_THREADS = 'getAllSentimentAnalysisThreads',
  GET_CALENDAR_BY_CAMPAIGN = 'getCalendarByCampaign',
  GET_CALENDAR_BY_CATEGORY = 'getCalendarByCategory',
  GET_CAMPAIGNS = 'getCampaigns',
  GET_CAMPAIGNS_OVERVIEW = 'getCampaignsOverview',
  GET_CAMPAIGN_BY_ID = 'getCampaignById',
  GET_CAMPAIGN_CATEGORIES = 'getCampaignCategories',
  GET_CAMPAIGN_COMMENTS = 'getCampaignComments',
  GET_CAMPAIGN_COMPARISON = 'getCampaignComparison',
  GET_CAMPAIGN_COMPARISONS = 'getCampaignComparisons',
  GET_CAMPAIGN_TARGETS = 'getCampaignTargets',
  GET_CAMPAIGN_TOP_LOCATION = 'getCampaignTopLocation',
  GET_CAMPAIGN_TOP_SOURCE = 'getCampaignTopSource',
  GET_COMPANY_PROFILE = 'getCompanyProfile',
  GET_CONTENT_ANALYSIS = 'getContentAnalysis',
  GET_CONTENT_ANALYSIS_ACTIVE_DATE_RANGE = 'getContentAnalysisActiveDateRange',
  GET_CONTENT_ANALYSIS_ACTIVITY_FREQUENCY = 'getContentAnalysisActivityFrequency',
  GET_CONTENT_ANALYSIS_CATEGORIES = 'getContentAnalysisCategories',
  GET_CONTENT_ANALYSIS_CATEGORY_COMMENTS = 'getContentAnalysisCategoryComments',
  GET_CONTENT_ANALYSIS_CATEGORY_INSIGHT = 'getContentAnalysisCategoryInsight',
  GET_CONTENT_ANALYSIS_COMMENTS = 'getContentAnalysisComments',
  GET_CONTENT_ANALYSIS_CONTENT_PERFORMANCE = 'getContentAnalysisContentPerformance',
  GET_CONTENT_ANALYSIS_ENGAGEMENT_INSIGHTS = 'getContentAnalysisEngagementInsights',
  GET_CONTENT_ANALYSIS_INDIVIDUAL_POSTS = 'getContentAnalysisIndividualPosts',
  GET_CONTENT_ANALYSIS_LIST = 'getContentAnalysisList',
  GET_CONTENT_ANALYSIS_SMART_INSIGHTS = 'getContentAnalysisSmartInsights',
  GET_CONTENT_ANALYSIS_SUMMARY = 'getContentAnalysisSummary',
  GET_CONTENT_ANALYSIS_TOPICS = 'getContentAnalysisTopics',
  GET_CONTENT_ANALYSIS_TOPIC_DETAIL = 'getContentAnalysisTopicDetail',
  GET_CONTENT_ANALYSIS_V2_OVERVIEW = 'getContentAnalysisV2Overview',
  GET_CONTENT_COMPARISON = 'getContentComparison',
  GET_CONTENT_COMPARISONS = 'getContentComparisons',
  GET_CONVERSATION_CATEGORIZATION = 'getConversationCategorization',
  GET_CREDITS = 'getCredits',
  GET_CUSTOM_REPORTS = 'getCustomReports',
  GET_CUSTOM_REPORTS_SUMMARY = 'getCustomReportsSummary',
  GET_DAILY_POSITIVITY_CAMPAIGN = 'getDailyPositivityCampaign',
  GET_DAILY_TRENDS = 'getDailyTrends',
  GET_DAILY_TRENDS_BY_CAMPAIGN = 'getDailyTrendsByCampaign',
  GET_DAILY_TRENDS_BY_CATEGORY = 'getDailyTrendsByCategory',
  GET_DAILY_TRENDS_BY_KEYWORD = 'getDailyTrendsByKeyword',
  GET_DATA_COMPARISON = 'getDataComparison',
  GET_DATA_COMPARISONS = 'getDataComparisons',
  GET_FACEBOOK_LOGIN = 'getFacebookLogin',
  GET_FREQUENTLY_USED_KEYWORDS = 'getFrequentlyUsedKeywords',
  GET_HOME_CALENDAR = 'getHomeCalendar',
  GET_HOME_CALENDAR_DETAILS = 'getHomeCalendarDetails',
  GET_HOT_LINKS = 'getHotLinks',
  GET_INBOX_ACTIVE_DATE_RANGE = 'getInboxActiveDateRange',
  GET_INBOX_ANALYSIS_PAGES = 'getInboxAnalysisPages',
  GET_INBOX_AVAILABLE_PLATFORMS = 'getInboxAvailablePlatforms',
  GET_INBOX_META_INSIGHTS = 'getInboxMetaInsights',
  GET_INBOX_OVERVIEW = 'getInboxOverview',
  GET_INBOX_OVERVIEW_SUMMARY = 'getInboxOverviewSummary',
  GET_INBOX_PREVIEW_CONVERSATIONS = 'getInboxPreviewConversations',
  GET_INBOX_PREVIEW_CONVERSATION_MESSAGES = 'getInboxPreviewConversationMessages',
  GET_INBOX_PREVIEW_SUMMARY = 'getInboxPreviewSummary',
  GET_INBOX_SMART_INSIGHTS = 'getInboxSmartInsights',
  GET_INVOICES = 'getInvoices',
  GET_KEYWORDS_ANALYSIS = 'getKeywordsAnalysis',
  GET_KEYWORDS_WITH_STATS = 'getKeywordsWithStats',
  GET_LOCATIONS = 'getLocations',
  GET_MESSAGE_VOLUME_TRENDS = 'getMessageVolumeTrends',
  GET_MONITORING_PAGES = 'getMonitoringPages',
  GET_MOST_MENTIONS = 'getMostMentions',
  GET_NEGATIVE_LIVE_NOTIFICATIONS = 'getNegativeLiveNotifications',
  GET_NEG_SENTIMENT_ANALYSIS_THREADS = 'getNegSentimentAnalysisThreads',
  GET_NEUTRAL_LIVE_NOTIFICATIONS = 'getNeutralLiveNotifications',
  GET_NEU_SENTIMENT_ANALYSIS_THREADS = 'getNeuSentimentAnalysisThreads',
  GET_OPERATOR_ANALYTICS = 'getOperatorAnalytics',
  GET_OPERATOR_PERFORMANCE = 'getOperatorPerformance',
  GET_OVERVIEW = 'getOverview',
  GET_PAYMENT_METHODS = 'getPaymentMethods',
  GET_POSITIVE_LIVE_NOTIFICATIONS = 'getPositiveLiveNotifications',
  GET_POSITIVITY_PERCENT = 'getPositivityPercent',
  GET_POS_SENTIMENT_ANALYSIS_THREADS = 'getPosSentimentAnalysisThreads',
  GET_PROJECT = 'getProject',
  GET_PROJECTS = 'getProjects',
  GET_PROJECT_DASHBOARD = 'getProjectDashboard',
  GET_PROJECT_SMART_INSIGHTS = 'getProjectSmartInsights',
  GET_QUICK_DETAILS = 'getQuickDetails',
  GET_RADAR_CHART = 'getRadarChart',
  GET_RESPONSE_TIME_ANALYSIS = 'getResponseTimeAnalysis',
  GET_REVIEW_ANALYSIS_ACTIVE_DATE_RANGE = 'getReviewAnalysisActiveDateRange',
  GET_REVIEW_ANALYSIS_CAMPAIGN = 'getReviewAnalysisCampaign',
  GET_REVIEW_ANALYSIS_CAMPAIGNS = 'getReviewAnalysisCampaigns',
  GET_REVIEW_ANALYSIS_COMPARISON = 'getReviewAnalysisComparison',
  GET_REVIEW_ANALYSIS_COMPARISONS = 'getReviewAnalysisComparisons',
  GET_REVIEW_ANALYSIS_COMPARISON_FACILITIES = 'getReviewAnalysisComparisonFacilities',
  GET_REVIEW_ANALYSIS_COMPETITORS = 'getReviewAnalysisCompetitors',
  GET_REVIEW_ANALYSIS_COMPETITOR_TARGETS = 'getReviewAnalysisCompetitorTargets',
  GET_REVIEW_ANALYSIS_FACILITY_ACTIVITY = 'getReviewAnalysisFacilityActivity',
  GET_REVIEW_ANALYSIS_FACILITY_OVERVIEW = 'getReviewAnalysisFacilityOverview',
  GET_REVIEW_ANALYSIS_GUEST_REVIEWS = 'getReviewAnalysisGuestReviews',
  GET_REVIEW_ANALYSIS_OVERVIEW = 'getReviewAnalysisOverview',
  GET_REVIEW_ANALYSIS_PLATFORM_ACTIVITY = 'getReviewAnalysisPlatformActivity',
  GET_REVIEW_ANALYSIS_PLATFORM_ANALYSIS = 'getReviewAnalysisPlatformAnalysis',
  GET_REVIEW_ANALYSIS_REVIEWS = 'getReviewAnalysisReviews',
  GET_REVIEW_ANALYSIS_SMART_INSIGHTS = 'getReviewAnalysisSmartInsights',
  GET_REVIEW_ANALYSIS_SPIKE_BREAKDOWN = 'getReviewAnalysisSpikeBreakdown',
  GET_REVIEW_ANALYSIS_STATUS = 'getReviewAnalysisStatus',
  GET_REVIEW_ANALYSIS_SUPPORTED_PLATFORMS = 'getReviewAnalysisSupportedPlatforms',
  GET_REVIEW_ANALYSIS_TOPICS = 'getReviewAnalysisTopics',
  GET_REVIEW_ANALYSIS_TOPIC_DETAIL = 'getReviewAnalysisTopicDetail',
  GET_REVIEW_TOPICS_ANALYSIS = 'getReviewTopicsAnalysis',
  GET_REVIEW_TOPICS_ANALYSIS_OVERVIEW = 'getReviewTopicsAnalysisOverview',
  GET_REVIEW_TOPIC_ANALYSIS_DETAIL = 'getReviewTopicAnalysisDetail',
  GET_SELF = 'getSelf',
  GET_SENTIMENT_ANALYSIS_BY_CAMPAIGN = 'getSentimentAnalysisByCampaign',
  GET_SENTIMENT_ANALYSIS_BY_CATEGORY = 'getSentimentAnalysisByCategory',
  GET_SENTIMENT_ANALYSIS_BY_KEYWORD = 'getSentimentAnalysisByKeyword',
  GET_SENTIMENT_CHART_BY_CAMPAIGN = 'getSentimentChartByCampaign',
  GET_SENTIMENT_CHART_BY_CATEGORY = 'getSentimentChartByCategory',
  GET_SENTIMENT_CHART_BY_KEYWORD = 'getSentimentChartByKeyword',
  GET_SMART_INSIGHTS = 'getSmartInsights',
  GET_SUBSCRIPTION_PRICES = 'getSubscriptionPrices',
  GET_SUBSCRIPTION_STATUS = 'getSubscriptionStatus',
  GET_THREAD_DETAILS = 'getThreadDetails',
  GET_TOPICS_OVERVIEW = 'getTopicsOverview',
  GET_TOPICS_TABLE = 'getTopicsTable',
  GET_TOPIC_DETAIL = 'getTopicDetail',
  GET_TOP_INTENTS = 'getTopIntents',
  GET_TOP_INTENT_MESSAGES = 'getTopIntentMessages',
  GET_TOP_KEYWORDS = 'getTopKeywords',
  GET_TOP_PHRASES = 'getTopPhrases',
  GET_TOP_SOURCES_BY_CAMPAIGN = 'getTopSourcesByCampaign',
  GET_TOP_SOURCES_BY_CATEGORY = 'getTopSourcesByCategory',
  GET_TOP_SOURCES_BY_KEYWORD = 'getTopSourcesByKeyword',
  GET_TRIAL_STATUS = 'getTrialStatus',
  GET_TRIPADVISOR_PLACES = 'getTripAdvisorPlaces',
  GET_USER_FEATURES = 'getUserFeatures',
  INFORMATION_TOOLTIPS = 'informationTooltips',
  SUGGESTIONS_CATEGORIES = 'suggestionsCategories',
  SUGGEST_WORD = 'suggestWord',
  SUGGEST_WORD_CREATE_CAMPAIGN_KEYWORD = 'suggestWordCreateCampaignKeyword',
}
